<template>
  <div>
    <!-- 发票列表审核 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>发票列表审核</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card style="margin-top:20px">
      <div>
        <el-row class="conentRow">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-button class="conentBtn" type="primary" @click="chaxun">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="addtime" label="开票日期"></el-table-column>
          <el-table-column prop="invoice" label="发票代码/发票号码"></el-table-column>
          <el-table-column prop="money" label="已开票金额"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <img src="@/images/distributor/dl.png" alt="" v-if="scope.row.state=='1'||scope.row.state == 4">
              <img src="@/images/distributor/dh.png" alt="" v-if="scope.row.state=='2'||scope.row.state == 3">
              <span  style="margin-left:10px">    {{ scope.row.state == 1 ? "通过" : scope.row.state == 2 ? "驳回" : scope.row.state == 3 ? "未审核" : scope.row.state == 4 ? "已打款":"" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="paymentFn(scope.row)" v-if="scope.row.state=='3'">打款</el-button>
              <el-button type="text" @click="xftjDetailFn(scope.row)" v-if="scope.row.state=='3'||scope.row.state=='2'">审核</el-button>
              <el-button type="text" @click="xftjDetailFn(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total"  :current-page.sync="data.page"  @current-change="currenchange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-card>
    <!-- 销售统计查看详情开始 -->
    <!-- <directStaDialog v-if="xstjinfovisible" ref="xstjinfoDialog"></directStaDialog> -->
    <!-- 销售统计查看详情结束 -->
    <!-- 消费统计明细开始 -->
    <!-- <sellStaDialog v-if="detailvisible" ref="detailDialog"></sellStaDialog> -->
    <!-- 消费统计明细结束 -->
    <!-- 退票统计明细开始 -->
    <!-- <sellStaDialog v-if="refundTicketvisible" ref="refundTicketDialog"></sellStaDialog> -->
    <!-- 退票统计明细结束 -->
    <orderQueryDialog v-if="detailvisible" ref="QueryDialog" @close="SetClose" :id="id"></orderQueryDialog>

    <el-dialog :close-on-click-modal="false"
      title="打款"
      :visible.sync="Payment"
      :before-close="PaymentClose"
      width="30.8%"
      center
      >
      <el-divider></el-divider>
      <div class="pay">
        <el-form ref="payform" :model="payform" label-width="100px" :rules="payrules">
          <el-form-item label="打款金额：" prop="money">
            <el-input v-model="payform.money" placeholder="请输入打款金额"></el-input>
              <span style="marginLeft:10px;">元</span>
          </el-form-item>
          <el-form-item label="打款日期：" prop="remit_date">
            <el-date-picker
              v-model="payform.remit_date"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="账号：" prop="number">
            <el-input v-model="payform.number" placeholder="请输入打款账号"></el-input>
          </el-form-item>
          <el-form-item label="打卡凭证：" prop="img">
            <el-upload
                class="avatar-uploader"
                action="http://xwt.softykt.net/api/close/uploadInfoRemit"
                :show-file-list="false"
                :on-success="handleAvatarSuccess">
                <img v-if="payform.img" :src="payform.img" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> 
          </el-form-item>
              <div class="paybtns">
                <el-button @click="resetting">重置</el-button>
              <el-button @click="payBtn('payform')">确认保存</el-button>
              </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {getInfoCloseList,addInfoRemit} from '@/request/distributor.js'
// import sellStaDialog from "./dialog/sellStaDialog.vue";
import orderQueryDialog from './dialog/orderQueryDialog.vue'; 
export default {
  components: {
    // sellStaDialog
    orderQueryDialog
  },
  data() {
    return {
      Payment:false, // 打款
      payform:{
        token:window.sessionStorage.getItem('Token'),
        money:'', // 金额
        remit_date:'', // 时间
        number:'', // 账号
        img:''
      }, // 打款信息
      payrules:{
        money:[
            { required: true, message: '请输入打款金额', trigger: 'blur' }
          ], // 金额
          remit_date:[
            {  required: true, message: '请选择打款时间', trigger: 'change' }
          ], // 时间
        number:[
            { required: true, message: '请输入打款账号', trigger: 'blur' }
          ], // 账号
          img:[ { required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
      xstjinfovisible: false, // 销售统计查看详情
      detailvisible: false, // 消费统计明细
      refundTicketvisible: false, // 退票统计明细
      tableData: [
      ],
      upOption: [
        {
          id: 1,
          value: "是"
        },
        {
          id: 2,
          value: "否"
        }
      ],
      value: "",
      value1: "",
      value: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8,
        start_time:"",
        end_time:""
      },
      total:0,
      id:""
    };
  },
  created(){
    this.getList()
  },
  methods: {
    // 打款弹框上传图片
    handleAvatarSuccess(res){
      this.payform.img= res.result
    },
    // 关闭打款弹框
    PaymentClose(){
      this.Payment = false
    },
    // 打开打款弹框
    paymentFn(row){
      console.log(row)
      this.payform.closeid= row.closeid
      this.Payment = true
    },
    // 打款重置
    resetting(){
      this.payform={
        money:'', // 金额
        remit_date:'', // 时间
        number:'', // 账号
        img:''
      }
    },
    payBtn(payform){
      this.$refs.payform.validate(valid=>{
        if(valid){
          addInfoRemit(this.payform).then(res=>{
            if(res.data.status=='ok'){
              this.getList()
              this.Payment = false
              this.message.success('打款成功')
            }else{
              this.message.erroe(res.data.msg)
            }
          })

        }else{

        }
      }) 
    },
    // 发票列表
    getList(){
      getInfoCloseList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    chaxun(){
      this.data.page = 1
      if(this.value1){
        this.data.start_time = this.value1[0]  + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
        this.getList()
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
        this.getList()
      }
    },
    // 发票信息
    xftjDetailFn(row) {
      this.id = row.id
      this.detailvisible = true;
      this.$nextTick(() => {
        this.$refs.QueryDialog.invoice(row);
      });
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    // 关闭详情
    SetClose(){
      this.detailvisible = false
      this.getList()
    }
  }
};
</script>

<style lang='less' scoped>
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
}

// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/.el-table__footer-wrapper tbody td.el-table__cell,
.el-table__header-wrapper tbody td.el-table__cell {
  background-color: #f5f7fa;
  color: #606266;
  text-align: center;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
.pay /deep/ .el-form-item__content{
  display: flex;
  align-items: center;
}
/deep/ .avatar-uploader{
  width: 10rem;
  height: 7rem;
  border: 1px solid #E5E5EA;
  border-radius: 4px;

}/deep/ .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-upload img{
  width: 100%;
  height: 100%;
}
.paybtns {
  width: 100%;
  display: flex;
  justify-content: center;
}
.paybtns button:nth-child(1){
  background: #D9D9D9;
  color: #fff;
  margin-right: 2rem;

}
.paybtns button:nth-child(2){
  background: #246DEB;
  color: #fff;
  
}
</style>